<template>
<div class="banner">
    <div class="swiper-container">
        <swiper class="swiper-wrapper" :options="swiperOption" ref="bannerSwiper">
            <swiper-slide class="swiper-slide" v-for="(item,index) in data" :key="index" :realIndex="index" @click="gotoDetails(item.action_status,item.id)">
                <img class="img" :src="item.photo" alt=""  :style="{'width':imageWidth}">
                <img class="img-end" v-if="item.action_status" src="../../static/image/end.png" alt="">
            </swiper-slide>
            <!-- 分页器 -->
            <div class="swiper-pagination" slot="pagination"></div>
            <!-- 左右箭头 -->
            <!-- <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div> -->
        </swiper>

    </div>
</div>
</template>

<script>
export default {
    name: 'Banner',
    props: {
        data: Array,
        path: String
    },
    data() {
        return {
            imageWidth: document.body.scrollWidth+'px',
            swiperOption: {
                //显示分页
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    type: "bullets",

                },
                //设置点击箭头
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                //自动轮播

                notNextTick: true,
                // swiper configs 所有的配置同swiper官方api配置
                autoplay: 3000,
                speed: 400,
                setWrapperSize: true,
                autoHeight: true,
                pagination: ".swiper-pagination",
                paginationClickable: true,
                mousewheelControl: true,
                observeParents: true,
                disableOnInteraction: false,
                autoplayDisableOnInteraction: false,
                // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
                debugger: true,
                loop: true,
                // paginationBulletRender: function (swiper, index, className) {
                //     return '<span class="' + className + '">' + (index + 1) + '</span>';
                // }
            }
        }
    },
    mounted() {
        let vm =this;
        this.swiper.on("tap",function(e){
            var index = (e.activeIndex -1) % vm.data.length
            vm.gotoDetails(index)
        })
    },
    computed:{
        swiper(){
            return this.$refs.bannerSwiper.swiper
        }
    },
    methods: {
        gotoDetails(index) {
            let status = this.data[index].action_status;
            let id = this.data[index].id;
            if (status) {
                this.$router.push('')

            } else {
                this.$router.push(`${this.path}/${id}`)
            }
        }
    }
}
</script>

<style lang="less">
.banner {
    overflow: hidden;
    width: 100%;

    .swiper-container {
        .swiper-wrapper {
            .swiper-slide {
                width: 100vw;
                height: 400px;
                position: relative;

                .img {
                    display: block;
                    width: 100vw;
                    height: 400px;
                }

                .img-end {
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 100px;
                    height: 100px;
                }
            }

            .swiper-pagination-bullet {
                width: 20px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                font-size: 12px;
                color: #000;
                opacity: 1;
                background: rgba(0, 0, 0, 0.2);
            }

            .swiper-pagination-bullet-active {
                color: #fff;
                background: rgba(255, 255, 255, 0.6);
                
            }
        }
    }
}
</style>
